export const formatMillisToTime = (
  milliseconds: number | null | undefined,
  displayZeroValues = true,
  removeEmptyValues = false
): string => {
  if (!milliseconds && (displayZeroValues ? milliseconds !== 0 : true)) {
    return '-';
  }

  const validMilliseconds = milliseconds ?? 0;
  const hours = Math.floor(validMilliseconds / 3600000);
  const minutes = Math.floor((validMilliseconds % 3600000) / 60000);
  const seconds = Math.floor((validMilliseconds % 60000) / 1000);

  const timeUnits = [hours, minutes, seconds];
  const formattedUnits = timeUnits.map(unit => String(unit).padStart(2, '0'));

  // Find the first non-zero value to determine where to start
  const firstNonZeroIndex = formattedUnits.findIndex(unit => unit !== '00');

  // If all values are zero, return 00:00:00
  if (firstNonZeroIndex === -1) {
    return removeEmptyValues ? '00:00' : '00:00:00';
  }

  // If we want to remove empty values, slice from the first non-zero value
  if (removeEmptyValues) {
    return formattedUnits.slice(firstNonZeroIndex - 1).join(':');
  }

  return formattedUnits.join(':');
};
